import React from "react";
import cn from "classnames";
import { TariffRadio } from "./TariffRadio";

export const SelectableCard = ({
    title,
    subtitle,
    checked,
    onChange,
    className,
    badge
}) => {
    return (
        <div
            onClick={onChange}
            className={cn(
                "flex items-center justify-between px-5 py-4 rounded-[16px] min-h-[86px] border cursor-pointer",
                {
                    "bg-[#2B3135] border-transparent": checked,
                    "border-white/[12%]": !checked
                },
                className
            )}
        >
            <div className="pr-4">
                <div className="flex items-center gap-2">
                    <span className="block text-white text-sm leading-[22px]">
                        {title}
                    </span>
                    {badge}
                </div>
                {subtitle && (
                    <span className="block text-[#FFE8AE] text-xs leading-[20px] pt-[3px]">
                        {subtitle}
                    </span>
                )}
            </div>
            <TariffRadio checked={checked} onChange={onChange} />
        </div>
    );
};



